import api from "../../util/api";

export const  getVideoFiles = async (videoId) => {
    const response = await api.get(`v2/api/videos/${videoId}/files/`).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data.data;
}